import { render, staticRenderFns } from "./ProfileDirbookBtn.vue?vue&type=template&id=395bad84&"
import script from "./ProfileDirbookBtn.vue?vue&type=script&lang=js&"
export * from "./ProfileDirbookBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports